import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultPopularStrategiesData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'lifetime-gifting',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'lifetime-gifting-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Lifetime gifting',
                variant: 'h3',
              },
            },
            {
              id: 'item-annual-gifting',
              type: 'PresentationListItem',
              props: {
                title: 'Annual exclusion gifting',
                description:
                  'Utilize annual gifting up to the annual exclusion limit (currently $19,000 per recipient for 2026) to reduce the overall estate size incrementally.',
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'item-charitable',
              type: 'PresentationListItem',
              props: {
                title: 'Charitable gifts',
                description:
                  'Charitable gifting is a tax-free way to support causes that you care about and is an effective way of reducing your future estate tax liability. Charitable gifts are commonly made directly to the organization, through a Donor Advised Fund or through a Private Foundation.',
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
      {
        id: 'irrevocable-trusts',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'irrevocable-trusts-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Irrevocable trusts',
                variant: 'h3',
              },
            },
            {
              id: 'item-slat',
              type: 'PresentationListItem',
              props: {
                title: 'Spousal lifetime access trusts (SLATs)',
                description:
                  'Use SLATs to gift assets to an irrevocable trust for the benefit of your spouse, leveraging the higher exemption while retaining some indirect access to the assets.',
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'item-ilit',
              type: 'PresentationListItem',
              props: {
                title: 'Irrevocable life insurance trusts (ILITs)',
                description:
                  'Fund ILITs with life insurance policies to remove the policy proceeds from the taxable estate, efficiently planning for liquidity to cover estate taxes.',
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
      {
        id: 'medical-payments',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'medical-payments-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Medical and tuition payments',
                variant: 'h3',
              },
            },
            {
              id: 'item-medical',
              type: 'PresentationListItem',
              props: {
                title: 'Medical payments',
                description:
                  "You can pay for someone else's qualified medical expenses directly to the healthcare provider. These payments are not considered gifts and thus do not count against your annual gift tax exclusion or your lifetime gift and estate tax exemption.",
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'item-tuition',
              type: 'PresentationListItem',
              props: {
                title: 'Tuition payments',
                description:
                  "Similar to medical payments, you can pay for someone else's tuition directly to an educational institution without it being considered a taxable gift. These payments do not count against your annual gift tax exclusion or your lifetime gift and estate tax exemption.",
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
      {
        id: 'gst-planning',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'gst-planning-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Generation-skipping transfer (GST) tax planning',
                variant: 'h3',
              },
            },
            {
              id: 'item-gst',
              type: 'PresentationListItem',
              props: {
                title: 'GST exemption utilization',
                description:
                  "Using GST-exempt gifts is a strategic way to transfer wealth across multiple generations while minimizing taxes. Making GST-exempt gifts to children or to future generations ensures that transfers will not be taxed at both your passing and G2's passing.",
                iconType: 'shield',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
